import React, { ChangeEvent, FC } from "react";

interface CustomFormInputProps {
  title?: string;
  placeholder?: string;
  onChange: (
    event: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => void;
  type?: "text" | "textarea";
  value: string;
  customClass?: string;
  customContainer?: string;
  name: string;
  disabled?: boolean;
}

const CustomFormInput: FC<CustomFormInputProps> = ({
  title = "",
  placeholder = "",
  onChange,
  type = "text",
  value = "",
  customClass = "",
  name,
  disabled = false,
  customContainer = "",
}) => {
  return (
    <div className={`customFormInput w-full lg:w-[48%] ${customContainer}`}>
      {title && (
        <h5 className="font-medium text-themeInputTitleColor text-lg leading-10 ">
          {title}
        </h5>
      )}

      {type === "textarea" ? (
        <textarea
          name={name}
          value={value}
          onChange={onChange}
          className={`w-full shadow-sm my-2 font-semibold text-sm outline-none border border-themeInputBorder bg-white px-3 py-3 rounded-md ${customClass}`}
          placeholder={placeholder}
          disabled={disabled}
        />
      ) : (
        <input
          type="text"
          name={name}
          value={value}
          onChange={onChange}
          className={`w-full shadow-sm   font-semibold text-sm my-2 outline-none border border-themeInputBorder bg-white px-3 py-3 rounded-md ${customClass}`}
          placeholder={placeholder}
          disabled={disabled}
        />
      )}
    </div>
  );
};

export default CustomFormInput;
